import { createUseStyles } from 'react-jss';
const useActionButtonStyles = createUseStyles(() => ({
    container: {
        position: 'relative',
        width: ({ fullWidth }) => (fullWidth ? '100%' : 'auto'),
        display: 'flex',
        alignItems: 'center',
        maxHeight: '44px'
    },
    input: {
        width: ({ fullWidth }) => (fullWidth ? '100%' : 'auto'),
        minWidth: '14rem',
        border: '1px solid #E1E4EA',
        borderRadius: '12px',
        padding: '12px',
        paddingLeft: '36px',
        height: '44px',
        '&::placeholder': {
            color: '#99A0AE',
            fontSize: '14px',
            lineHeight: '20px'
        },
        '&:focus': {
            outline: 'none',
            border: '1px solid #335CFF'
        }
    },
    icon: {
        position: 'absolute',
        left: '12px',
        pointerEvents: 'none'
    }
}));
export default useActionButtonStyles;
